import { Archive } from 'lucide-react';
import GenericModulePage from './GenericModulePage';
import { mortuaryAPI } from '../lib/api';

const config = {
  title: 'Mortuary',
  subtitle: 'Death record logbook and body release log.',
  icon: Archive,
  permPrefix: 'mortuary',
  testId: 'mortuary',
  idLabel: 'Entry',
  fields: [
    { key: 'deceased_name', label: 'Deceased Name', type: 'text', required: true, listColumn: true },
    { key: 'patient_uhid', label: 'UHID', type: 'text', listColumn: true },
    { key: 'age', label: 'Age', type: 'number' },
    { key: 'gender', label: 'Gender', type: 'select', options: ['Male', 'Female', 'Other'] },
    { key: 'death_date', label: 'Date of Death', type: 'date', required: true, listColumn: true },
    { key: 'death_cause', label: 'Cause of Death', type: 'text' },
    { key: 'admitted_under', label: 'Admitted Under (Doctor)', type: 'text' },
    { key: 'body_storage', label: 'Body Storage / Chamber', type: 'text', listColumn: true },
    { key: 'status', label: 'Status', type: 'select', options: ['In Storage', 'Released to Family', 'Released to Authority', 'Unclaimed'], listColumn: true },
    { key: 'released_to', label: 'Released To', type: 'text' },
    { key: 'released_on', label: 'Released On', type: 'date' },
    { key: 'remarks', label: 'Remarks', type: 'textarea', fullWidth: true },
  ],
};

export default function MortuaryPage() { return <GenericModulePage config={config} apiClient={mortuaryAPI} />; }
